import { render, staticRenderFns } from "./Engineers.vue?vue&type=template&id=04988b97&"
import script from "./Engineers.vue?vue&type=script&lang=js&"
export * from "./Engineers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports